import script from "./SurveyResult.vue?vue&type=script&setup=true&lang=js"
export * from "./SurveyResult.vue?vue&type=script&setup=true&lang=js"

import "./SurveyResult.vue?vue&type=style&index=0&id=01e9bafd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01e9bafd"]])

export default __exports__